import { render, staticRenderFns } from "./RemainingBalanceUA.vue?vue&type=template&id=5b684662&"
import script from "./RemainingBalanceUA.vue?vue&type=script&lang=ts&"
export * from "./RemainingBalanceUA.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports